// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8309) return "static/chunks/8309.6407dec8e0370376.js";
	if (chunkId === 8337) return "static/chunks/8337.41699be1cc5aa502.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"157":"291d7c1debfb10b1","7643":"2decf18b3b3c6e0e","9175":"41acd9f54f60a8ff"}[chunkId] + ".js";
};